module.exports = __webpack_public_path__ + "assets/a-9-tizhongcheng.ed936034.svg";